module.exports = __webpack_public_path__ + "static/img/animation28.gif";